import {Component} from "react"
import {withRouter} from "react-router-dom"
import {connect} from "react-redux"
import { closeModal } from "../actions"

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
      this.props.dispatch(closeModal())
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(connect(null)(ScrollToTop));